import { render, staticRenderFns } from "./TrafficReport.vue?vue&type=template&id=194f1a22&"
import script from "./TrafficReport.vue?vue&type=script&lang=js&"
export * from "./TrafficReport.vue?vue&type=script&lang=js&"
import style0 from "./TrafficReport.vue?vue&type=style&index=0&id=194f1a22&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QPage,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QPage,QIcon})
